module.exports = __webpack_public_path__ + "static/media/login-cover-img.34467db0.png";